<template>
    <div>
        <button :disabled="disabled" class="c-button--reset c-dialog__toggle c-button c-button--fullwidth c-dialog__button" @click.prevent="toggleDialog" :class="[customButtonClass]">
            <slot name="buttonContent"></slot>
        </button>
        <div :id="`${_uid}_dialog`" :aria-hidden="!open" v-if="open">
            <div class="c-dialog-overlay" tabindex="-1" data-a11y-dialog-hide @click="closeDialog()"></div>
            <div class="c-dialog-parent">
                <div class="c-dialog" role="dialog" aria-labelledby="dialog-title">
                    <div role="document">
                        <button class="c-button--reset c-button--icon-only c-dialog__close" type="button" data-a11y-dialog-hide :aria-label="$t('dialog.close')" @click="closeDialog()">
                            <svgicon name="close"></svgicon>
                        </button>
                        <div class="u-text-align-center">
                            <h1 class="c-dialog__title" id="dialog-title">
                                <slot name="title"></slot>
                            </h1>
                        </div>
                        <div class="c-dialog-inner">
                            <slot></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .c-dialog__button_send-reminders {
        margin-bottom: em($global-spacing-unit-small);
    }

    .c-dialog__title {
        display: inline-block;
        position: relative;
        color: initial;
        @include rfs($font-size-large);
        padding-bottom: em($global-spacing-unit-tiny);

        &:after {
            position: absolute;
            content: '';
            height: 3px;
            width: em(40px);
            background-color: $color-alpha;
            left: 50%;
            bottom: -3px;
            transform: translateX(-50%);
        }
    }

    .c-dialog-parent {
        position: fixed;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        z-index: 51;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        max-height: 100vh;
        overflow-y: auto;
        padding: em($global-spacing-unit-huge);
    }

    .c-dialog-overlay {
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: rgba(white, .7);
        z-index: 50;
    }

    .c-dialog {
        position: relative;
        width: 100%;
        max-width: em(800px);
        background-color: white;
        box-shadow: 0 0 70px 0 rgba($color-base, .075), 0 0 0 3px rgba($color-base, .1);
        padding: em($global-spacing-unit);
    }

    .c-dialog[aria-hidden='true'] {
        display: none;
    }

    .c-dialog__close {
        padding: 0;
        height: em(40px);
        width: em(40px);
        position: absolute;
        top: em(9px);
        right: em(9px);
        z-index: 1;
    }
</style>

<script>
    import Vue from 'vue'
    import vClickOutside from 'v-click-outside';

    // Register outside Click plugin
    Vue.use(vClickOutside);

    export default {
        components: {},
        props: {
            disabled: {type: Boolean, default: false},
            'title': String,
            'state': Boolean,
            'customButtonClass': String,
        },
        data() {
            return {
                instance: '',
                open: this.state
            }
        },
        watch: {
            state() {
                this.open = this.state;
            },
        },
        mounted() {
            document.addEventListener("keydown", (e) => {
                if (this.open && e.keyCode === 27) {
                    this.closeDialog();
                }
            });
        },
        methods: {
            closeDialog() {
                this.open = false;
                this.$emit('update:state', this.open);
                this.$emit('closed');
                document.querySelector('html').classList.remove('modal-is-open');
            },
            openDialog() {
                this.open = true;
                this.$emit('update:state', this.open);
                this.$emit('opened');
                document.querySelector('html').classList.add('modal-is-open');
            },
            toggleDialog() {
                this.open = !this.open;
                document.querySelector('html').classList.add('modal-is-open');
                this.$emit('update:state', this.open);
                this.$emit('opened');
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/modal/Modal.vue